export const autocompleteTypes = {
  skills: "skills",
  workCategories: "work_categories",
  works: "works",
  recruiters: "recruiters",
  skillCategory: "skill_category",
};
